<template>
  <Payment :type="2" :id="id"></Payment>
</template>

<script>
import Payment from './components/payment'
export default {
  name: 'CustomerPayment',
  components: {Payment},
  data () {
    return {
      id: null,
      parent: null,
      nowType: null
    }
  },
  created () {},
  mounted () {
    this.id = this.$route.query.id
    this.parent = this.$route.query.parent
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/customer/customerPayment.vue